import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Box from '../components/Box'
import PropertyLabel from '../components/PropertyLabel'
import AssignedItemList from '../components/AssignedItemList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import { fetchContract, updateContract } from '../actions/contracts'
import { getLockersName } from '../utils/machines'
import '../styles/ContractDetailsView.css'

class ContractDetailsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      closing: false,
      terminateConfirmShown: false
    }

    this.terminateContract = this.terminateContract.bind(this)
    this.terminateConfirmShow = this.terminateConfirmShow.bind(this)
    this.terminateConfirmToggle = this.terminateConfirmToggle.bind(this)
  }

  componentDidMount() {
    this.props.fetchContract(this.props.match.params.id)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.deleting && !nextProps.loading) {
      this.props.push('/contracts')
    }
  }

  terminateContract() {
    const { updateContract, contract } = this.props

    this.setState({ deleting: true })
    updateContract(contract.number, { ...contract, Status: 'TERMINATED' })
  }

  terminateConfirmShow() {
    this.setState({ terminateConfirmShown: true })
  }

  terminateConfirmToggle() {
    this.setState({ terminateConfirmShown: !this.state.terminateConfirmShown })
  }

  workingMode(type) {
    switch (type) {
      case "0":
        return "MTO DIARIO"
      case "1":
        return "MTO DIARIO + SERVICIOS"
      case "2":
        return "MTO DIARIO TIEMPO SIN PIN"
      case "3":
        return "MTO DIARIO TIEMPO CON PIN"
      case "4":
        return "OTO DIARIO SIN PIN"
      case "5":
        return "OTO DIARIO CON PIN"
      case "6":
        return "RESERVA ANTICIPADA"
      case "7":
        return "TAQUILLAS AQUARIAZ"
    }
  }

  formatMinutesToHHMM = (minutes) => {
    const hrs = String(Math.floor(minutes / 60));
    const mins = String(minutes % 60).padStart(2, '0');
    return `${hrs}:${mins}`;
  };

  renderTicketPreview() {
    const { contract } = this.props;
    
    // Prepare items for display, with fallback example
    const displayItems = contract.Items && contract.Items.length > 0 
      ? contract.Items.map(item => ({
          name: getLockersName(item.item),
          price: item.price
        }))
      : [{ name: 'Standard locker', price: 5 }];
    
    // Calculate totals
    const currency = contract.Currency || 'EUR';
    const conversionRate = contract.ConversionRate || 1;
    
    // Calculate subtotal (base)
    const subtotal = displayItems.reduce((sum, item) => {
      return sum + ((item.price || 5) * conversionRate);
    }, 0);
    
    // Extract IVA percentage from TicketIVA or use default 21%
    const ivaMatch = contract.TicketIVA ? contract.TicketIVA.match(/(\d+)%/) : null;
    const ivaPercentage = ivaMatch ? parseFloat(ivaMatch[1]) : 21;
    
    // Calculate IVA amount
    const ivaAmount = subtotal * (ivaPercentage / 100);
    
    // Calculate total
    const total = subtotal + ivaAmount;
    
    return (
      <div className="ticket-preview-container">
        <div className="ticket-paper">
          <div className="ticket-content">
            {/* Header */}
            <div className="ticket-header">
              {contract.TicketHeader && contract.TicketHeader.split('\n').map((line, idx) => (
                <div key={idx} className="ticket-line">{line || ' '}</div>
              ))}
            </div>
            
            <div className="ticket-divider">========================================</div>
            
            {/* Items */}
            <div className="ticket-items">
              {displayItems.map((item, idx) => (
                <div key={idx} className="ticket-item">
                  <div className="ticket-item-name">{item.name}</div>
                  <div className="ticket-item-price">
                    {currency} {((item.price || 5) * conversionRate).toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="ticket-divider">========================================</div>
            
            {/* Price breakdown */}
            <div className="ticket-totals">
              <div className="ticket-item">
                <div className="ticket-item-name">Base imponible:</div>
                <div className="ticket-item-price">{currency} {subtotal.toFixed(2)}</div>
              </div>
              <div className="ticket-item">
                <div className="ticket-item-name">IVA ({ivaPercentage}%):</div>
                <div className="ticket-item-price">{currency} {ivaAmount.toFixed(2)}</div>
              </div>
              <div className="ticket-divider">- - - - - - - - - - - - - - - - - - - -</div>
              <div className="ticket-item ticket-total">
                <div className="ticket-item-name">TOTAL:</div>
                <div className="ticket-item-price">{currency} {total.toFixed(2)}</div>
              </div>
            </div>
            
            {/* IVA Info */}
            {contract.TicketIVA && (
              <div className="ticket-iva">
                <div className="ticket-line">{contract.TicketIVA}</div>
              </div>
            )}
            
            <div className="ticket-divider">========================================</div>
            
            {/* Footer */}
            <div className="ticket-footer">
              {contract.TicketFooter && contract.TicketFooter.split('\n').map((line, idx) => (
                <div key={idx} className="ticket-line">{line || ' '}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { role, type, contract, error, loading } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message} />
      )
    }

    if (!contract || loading) {
      return <LoadingProgress />;
    }

    return (
      <div className="contract-details-view">
        {/* Header Section */}
        <div className="ct-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-file-contract"></i> CONTRATO {contract.Machine.Serial}
                <span className={`ct-admin-badge ${contract.Status === 'VALID' ? 'success' : 'warning'}`}>
                  <i className={`fas ${contract.Status === 'VALID' ? 'fa-check-circle' : 'fa-pause-circle'}`}></i>
                  {contract.Status}
                </span>
              </h1>
            </div>
            {(role === 'ADMIN' && type === 'MASTER') && contract.Status === 'VALID' &&
              <div className="header-actions">
                <Link to={`/contracts/${contract._id}/edit`} className="ct-admin-btn primary">
                  <i className="fas fa-edit"></i><span>Editar</span>
                </Link>
                <button className="ct-admin-btn warning" onClick={this.terminateConfirmShow}>
                  <i className="fas fa-times-circle"></i><span>Terminar</span>
                </button>
              </div>
            }
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="contract-content-grid">
          
          {/* Column 1 - General Info */}
          <div className="contract-column">
            
            {/* Validity Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-calendar-alt mr-2"></i>
                Validez del Contrato
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-play-circle text-vw-light mr-2"></i>
                    Fecha inicio
                  </div>
                  <div className="info-value">
                    {(new Date(contract.StartDate)).toLocaleDateString('es-ES', { 
                      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' 
                    })}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-stop-circle text-vw-red mr-2"></i>
                    Fecha fin
                  </div>
                  <div className="info-value">
                    {(new Date(contract.EndDate)).toLocaleDateString('es-ES', { 
                      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' 
                    })}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user-edit text-vw-light mr-2"></i>
                    Última edición
                  </div>
                  <div className="info-value">{contract.Executor}</div>
                </div>
              </div>
            </div>

            {/* Customer Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-building mr-2"></i>
                Información del Cliente
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user mr-2"></i>
                    Cliente
                  </div>
                  <div className="info-value font-weight-bold">{contract.Customer.Fullname}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map-marker-alt mr-2"></i>
                    Zona
                  </div>
                  <div className="info-value">{contract.Zone}</div>
                </div>
                {contract.Customer.Sector &&
                  <div className="info-row">
                    <div className="info-label">
                      <i className="fas fa-layer-group mr-2"></i>
                      Sector
                    </div>
                    <div className="info-value">{contract.Customer.Sector.description}</div>
                  </div>
                }
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-location-arrow mr-2"></i>
                    Localización
                  </div>
                  <div className="info-value">{contract.Location}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-money-bill-wave mr-2"></i>
                    Moneda
                  </div>
                  <div className="info-value">{contract.Currency}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-exchange-alt mr-2"></i>
                    Tasa de conversión
                  </div>
                  <div className="info-value">{contract.ConversionRate}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-flag mr-2"></i>
                    Report AE Italia
                  </div>
                  <div className="info-value">{contract.ReportAE}</div>
                </div>
              </div>
            </div>

          </div>

          {/* Column 2 - Operation & Ticket */}
          <div className="contract-column">
            
            {/* Operation Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-cogs mr-2"></i>
                Configuración de Funcionamiento
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-power-off mr-2"></i>
                    Modo de trabajo
                  </div>
                  <div className="info-value">
                    <span className="badge badge-primary">
                      {this.workingMode(contract.WorkingMode)}
                    </span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-random mr-2"></i>
                    Modo híbrido
                  </div>
                  <div className="info-value">
                    <span className={`badge ${contract.HybridMode ? 'badge-success' : 'badge-secondary'}`}>
                      <i className={`fas ${contract.HybridMode ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                      {contract.HybridMode ? 'Activo' : 'Inactivo'}
                    </span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-clock mr-2"></i>
                    Rango de tiempo
                  </div>
                  <div className="info-value">{this.formatMinutesToHHMM(contract.TimeSlots)}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-gift mr-2"></i>
                    Tiempo de cortesía
                  </div>
                  <div className="info-value">{contract.TimeCourtesy} min</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-door-open mr-2"></i>
                    Acceso a local
                  </div>
                  <div className="info-value">
                    <span className={`badge ${contract.DoorAccess ? 'badge-success' : 'badge-secondary'}`}>
                      {contract.DoorAccess ? 'Habilitado' : 'Deshabilitado'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Ticket Preview Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-receipt mr-2"></i>
                Vista Previa del Ticket (58mm)
              </div>
              <div className="card-body-custom">
                {this.renderTicketPreview()}
              </div>
            </div>

          </div>

          {/* Column 3 - Items & Settings */}
          <div className="contract-column">
            
            {/* Pricing Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-shopping-cart mr-2"></i>
                Artículos y Precios
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-calendar-day mr-2"></i>
                    Sistema de precios
                  </div>
                  <div className="info-value">
                    {contract.Calendar ? (
                      <span className="badge badge-info">
                        <i className="fas fa-calendar-alt mr-1"></i>
                        {contract.Calendar.Name}
                      </span>
                    ) : (
                      <span className="badge badge-secondary">
                        <i className="fas fa-dollar-sign mr-1"></i>
                        Precios fijos
                      </span>
                    )}
                  </div>
                </div>
                
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-laptop mr-2"></i>
                    Calendario local
                  </div>
                  <div className="info-value">
                    <span className={`badge ${contract.LocalCalendar ? 'badge-success' : 'badge-warning'}`}>
                      <i className={`fas ${contract.LocalCalendar ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                      {contract.LocalCalendar ? 'Activo - Precios dinámicos locales' : 'Inactivo - Precios fijos del contrato'}
                    </span>
                  </div>
                </div>
                
                {contract.LocalCalendar && (
                  <div className="alert alert-info" style={{ fontSize: '12px', marginTop: '10px' }}>
                    <i className="fas fa-info-circle mr-1"></i>
                    La máquina usará los precios dinámicos del calendario en lugar de los precios fijos del contrato.
                  </div>
                )}
                
                <hr />
                <AssignedItemList 
                  items={contract.Items} 
                  currency={contract.Currency} 
                  conversionRate={contract.ConversionRate} 
                />
              </div>
            </div>

            {/* Terms & Start Message Card */}
            <div className="contract-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-file-alt mr-2"></i>
                Configuración Adicional
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-gavel mr-2"></i>
                    Términos y condiciones
                  </div>
                  <div className="info-value">
                    {contract.TermsLink ? (
                      <a href={contract.TermsLink} target="_blank" rel="noopener noreferrer" 
                         className="text-vw-light">
                        <i className="fas fa-external-link-alt mr-1"></i>
                        Ver términos
                      </a>
                    ) : (
                      <span className="text-muted">No configurado</span>
                    )}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-comment-dots mr-2"></i>
                    Mensaje en Start
                  </div>
                  <div className="info-value">
                    {contract.StartMessage ? (
                      <div className="start-message-box">
                        {contract.StartMessage}
                      </div>
                    ) : (
                      <span className="text-muted">No configurado</span>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Confirm terminate */}
        <div>
          <Modal isOpen={this.state.terminateConfirmShown}
            toggle={this.terminateConfirmToggle}>
            <ModalHeader toggle={this.terminateConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de terminar el contrato?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.terminateContract}>
                Terminar
              </Button>
              <Button color="secondary" onClick={this.terminateConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}



const mapStateToProps = state => ({
  contract: state.contracts.contract,
  loading: state.contracts.loading,
  error: state.contracts.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchContract: bindActionCreators(fetchContract, dispatch),
  updateContract: bindActionCreators(updateContract, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ContractDetailsView)


